import { useEffect } from 'react';
import { LSTORAGE_KEY, SESSION_KEY } from 'src/constants';
import { LocalStore, SessionStore } from 'src/utils';
import { mergeOverride } from 'src/utils/array';

interface IProps {
    eleRef: any;
    index: number;
    type: string;
    contentId?: number;
    intersectionObserverOptions?: IntersectionObserverInit;
}

export function useViewParagraphCount({
    eleRef,
    index,
    contentId = 0,
    intersectionObserverOptions = {
        rootMargin: '0px',
    },
}: IProps): [number] {
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const BM = (window as any)._BM;
                    BM.currentIndex = Math.max(BM.currentIndex, index);
                    const data = LocalStore.get(LSTORAGE_KEY.VIEW_DETAIL) || {};
                    const ssid = SessionStore.get(SESSION_KEY.SSID);
                    let strUserId = LocalStore.get(LSTORAGE_KEY.BM_UID) || (window as any).dataAuth?.strUserId;

                    const object = {
                        [contentId]: {
                            uid: strUserId,
                            value: contentId,
                            session_id: strUserId
                                ? strUserId + '_' + ssid
                                : ssid,
                            total_body_paragraph: BM.bodyLength,
                            sections: [
                                {
                                    section: 'body',
                                    viewed_paragraph: BM.currentIndex + 1,
                                },
                            ],
                        },
                    };

                    const _data = mergeOverride(data, object);
                    LocalStore.set(LSTORAGE_KEY.VIEW_DETAIL, _data);
                    observer.unobserve(entry.target);
                }
            });
        }, intersectionObserverOptions);

        if (eleRef && eleRef.current) {
            observer.observe(eleRef.current);
        }

        return () => {
            if (eleRef && eleRef.current) {
                observer.disconnect();
            }
        };
    }, [eleRef]);

    return [index];
}

export default useViewParagraphCount;
